var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgContribution = function SvgContribution(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prime account"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 30,
    height: 30,
    rx: 15,
    fill: "#FFF28C"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    width: 30,
    height: 30,
    rx: 15,
    fill: "#FFF28C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon",
    d: "M12.8138 21.7434C13.9994 23.0115 16.0106 23.0115 17.1963 21.7434L22.5702 15.9963C23.3335 15.1801 23.4623 13.9565 22.8859 12.9992L21.6438 10.9366C20.9202 9.73485 19.6199 9.00001 18.2171 9.00001H11.7929C10.3901 9.00001 9.08984 9.73485 8.3662 10.9366L7.12418 12.9992C6.54773 13.9565 6.67659 15.1801 7.43981 15.9963L12.8138 21.7434Z",
    stroke: "#4D4408",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 70",
    d: "M11.5 14H18.5",
    stroke: "#4D4408",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgContribution);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/contribution.0f9c2845.svg";